module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('em', [_vm._v("Chapter Two")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("T")]), _vm._v("he loud, laughing voices of a family with teenagers walking past her motel room door finally roused Angie to her surroundings. Hardly any light was coming through the window, creating shadows in the room. She switched on the lamp by the bed and glanced at her watch. It was after six. There was a lost sensation that so much time had gone by without her being aware of it. The giddy weakness she felt was obviously caused by hunger. It was suddenly important to have a purpose, even if it was something as basic as eating.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Her purse was on the bed. It took Angie a minute to find the key to the room. Considering how disoriented she had been when she arrived at her motel room, she found the ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("small restaurant attached to the motel with surprising ease. A few patrons were already there, but Angie found a quiet table off by herself and sat down.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Loud music from a jukebox filtered through the door that connected the restaurant to the adjoining bar. The laughter and camaraderie coming from the other side seemed alien to Angie. The world weighed so heavily on her shoulders, a cumbersome yoke of depression pulling her spirits down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The evening special on the restaurant’s menu was red snapper which the waitress recommended very highly. Angie ordered it. The meal was not only tasty, but the nourishment also chased away some of her leaden-ness. She felt buoyed by it, briefly lifted out of that canyon of despair when she finished her meal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that purpose over, the evening stretched emptily ahead of her. It became mandatory not to think after the wasted afternoon when she had thought herself into a daze of confusion. The noise from the bar beckoned to her as Angie went to the cash register to pay for her meal. A coin-operated cigarette machine stood against the wall. Angie added another bill to the money she handed the cashier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some change for cigarettes, please,” she requested, even though she’d quit smoking more than four years ago. Tonight Angie wanted the companionship of a cigarette.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("With the package of cigarettes and a match book ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("in her purse, Angie walked to the connecting door to the bar. Typically, the lighting inside was dim. She had to wait a couple of seconds inside the doorway to give her eyes a chance to adjust to the absence of light.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All the inhabitants seemed to be male, an unusual mixture of cowboys and shrimpers. No one was sitting on the stools at the end of the bar. Angie made her way quietly to the last one. Her appearance didn’t go unnoticed. She received more than one interested and appraising look, but her posture and attitude didn’t invite any overtures, much to the disappointment of the lookers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bartender was a dark-haired man in his late forties, his muscled bulk inclining to go to fat. There was a gruffness to his features and demeanor, but there was an extraordinary gentleness in his eyes when he paused across the counter from where Angie was seated on a tall barstool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’ll it be?” He rested his hairy hands on the counter’s edge and partially leaned his weight on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If she drank any liquor, it was usually white wine. But it seemed inappropriate to order that here. “A beer. Whatever you have on tap.” She wasn’t particular about brands.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("While Angie opened the pack of cigarettes, the bartender tipped a glass under a beer tap and filled it nearly full before setting a head on it. He carried it over and rummaged behind the counter until he found a paper ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("coaster to sit the glass on, then placed it in front of her.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t recall seeing you in here before,” he remarked with a faint welcoming smile. “Are you from here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I used to be,” Angie admitted and tore a match out of the book before striking it and holding the flame to her cigarette. She almost coughed when she inhaled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Back for a visit, huh?” the bartender surmised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” Angie didn’t object to company, but she wasn’t interested in conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The area has changed a lot—growing all the time. Tourists in the winter and tourists in the summer,” he observed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bartender took the hint from her one-syllable replies and wandered to the other end of the bar. Angie tapped her cigarette tip in the ashtray and sipped at the cold beer. She had vowed not to think, but she kept wondering what would happen if she called Marissa and immediately shied away from the prospect. She listened to the music playing on the jukebox, not hearing the lyrics.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("One cowboy continued to show an increasing interest in her, studying her with a curiously intent look as if trying to place where he’d seen her before. A toasty brown mustache bushed and curled away from his upper lip. Dressed in Levis and a printed western shirt, he was wearing a spanking new Stetson ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("with a decorative featherband. He stared at Angle until he couldn’t contain his curiosity any longer and pushed out of his chair to cross the room.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Angie noticed him when he leaned sideways against the bar facing her stool. There was a suggestion of a smile to his mouth, but the curving line disappeared into the mustache. Coolly ignoring him, she turned away. His blue eyes narrowed in thoughtful, yet confused speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is either going to sound like a bad line from an old movie or an old line from a bad movie,” he began, “but—don’t I know you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A little chill ran down her spine. Angie glanced briefly at the cowboy again, seeing something vaguely familiar about his features. “No, I don’t think you do,” she denied even though she wasn’t sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m just positive we’ve met somewhere before,” he insisted with a slight shake of his head. “Do you live around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” She’d put her cigarette out barely a minute ago, but she was suddenly apprehensive and reached for another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The snap of a metallic lighter sounded as the cowboy offered her its flame. Angie let him light her cigarette, but avoided contact with his sharp gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve done some traveling myself. Where are you from?” he asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“Arizona.” She curled her hands around the beer glass, studying the smoke swirling from ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("the cigarette between her fingers. She felt wary and on edge.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a rueful grimace at her answer. “I’ve never been there.” He paused to study her profile again. “I know we’ve met before. It’s embarrassing to think I could forget those blue eyes or that naturally blond hair.” Angie didn’t respond to the implied compliment. “I never introduced myself. The name is Kelly. Kelly Reynolds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His name rippled through her like a miniature shock wave. That was the name she hadn’t been able to recall earlier. It belonged to the young man Marissa had been dating that summer seven years ago. Kelly knew her. After seven years, he simply hadn’t recognized her—and she hadn’t recognized him. Angie struggled to keep her reaction from showing—to conceal that his name meant anything to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, but I’ve never heard the name before,” she lied, feigning indifference and deliberately failing to tell him her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d swear I know you.” He continued to scrutinize her, much to Angie’s dismay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tried to appear nonchalant. “I probably remind you of someone else. It happens.” She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” Kelly sounded skeptical. He slid onto the vacant barstool next to her, not giving up. “To rephrase another bad line, what brings a nice girl like you to this sleepy Texas town? It’s a little off the beaten path.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("“I’ll borrow another old line.” The curved line of her mouth was stiff. “I’m just passing through.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“—and just happened to stop here for the night,” he concluded with continuing doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s hardly so unusual,” Angie defended. “I understand this area receives its share of tourists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess so,” Kelly conceded reluctantly. He lit a cigarette of his own and glanced sideways at her through the smoke. “Maybe it was San Antonio that we met.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve never been there.” Somehow she had to stop this conversation without rousing his suspicions further.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pursed his lips thoughtfully and motioned to the bartender. “I’ll have a beer, Al,” he ordered and sent another half-smiling glance at Angie. “Let me buy you a fresh drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, thanks,” she refused. “I’ve barely touched the one I have.” She took another sip, fully aware the beer had become flat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a lull as the bartender brought him a bottle of beer and a glass. Kelly dug the money out of his hip pocket to pay for it. When the bartender went to get his change, the cowboy turned his head to study Angie again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you say your name was?” he prompted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("This was becoming dangerous. Any minute he might remember her. What if he knew the story? What if he called Deke and told him she was in town? All hell would break loose. Was ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("she ready for that? Or was she willing to resign herself to the status quo? It was a decision Angie hadn’t been able to make yet. Soon Kelly Reynolds might force her into a course of action she might not want.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t tell you my name.” Her voice was frozen with icy cold fear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With an unnatural display of cowardice, Angie gathered the pack of cigarettes and matchbook, shoving them inside her purse. As she slid off the barstool to leave, he grabbed at her arm. Surprise was mixed with confusion in his expression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t go,” Kelly protested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s late and I’ve had a long day.” She firmly extricated herself from his hold. “Good night, Mr. Reynolds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she walked to the exit leading into the restaurant, Angie could feel his intent gaze burrowing into her back. Right up to the very last second, he was trying to place when and where he’d known her before. Angie had the feeling that she’d handled the situation badly, whetting his curiosity about her identity instead of diverting it. She should have made up a name, rather than refusing to tell him. Now it was too late. She was angry with herself—angry and a little scared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the door closed behind her, Kelly Reynolds turned back to the bar and folded his arms across its top. His heavy sigh betrayed his inner confused and troubled state. The bartender paused, eyeing him thoughtfully and with a trace of amusement.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“Strike out, did ya’, Kelly?” he mocked.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw.” Kelly picked up the bottle of beer and poured its liquid into the glass. His expression remained contemplative. “I’ve met that blond somewhere before. Dammit, I know I have.” There was more than a trace of frustration in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You probably have,” the bartender shrugged as he removed the partially empty glass of beer Angie had left. “She told me she used to live around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She lived here?” Kelly repeated on a surprised note, because she had denied it to him. “But—” He stopped in the middle of a half-formed protest. “Did she say when?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. But I had the impression it was a few years ago.” He looked at Kelly and smiled dryly. “I never realized there had been so many blonds in your life that you wouldn’t remember a number like that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what bugs me,” Kelly admitted on a disgruntled note. “I haven’t dated that many.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you didn’t date this one,” the bartender suggested. “It could be that she wouldn’t give you the time of day even back then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a moment of silence as Kelly studied the foamy top of his beer. Slowly he lifted his head, a dawning light glimmering in his eyes.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“That’s it,” he murmured. “She was dating someone else.” He snapped his fingers in sudden recall. “Deke. It was Deke. I was taking ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Marissa out then and we used to double with Deke and that blond. Damn.” He bit at his lower lip. “What was her name?” He muttered the question to himself. “Mandy? No. Tammy? No.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“When was this?” Now the bartender was curious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a little before Deke ran off and got married,” Kelly replied absently. “I wish I could remember her name. It’s going to drive me crazy until I think of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bartender’s train of thought traveled in a different direction, focusing on Deke Black-wood. “Ya’ know, I can’t help feeling sorry for Blackwood. The man’s sure had his share of grief, first losing his bride when she gave premature birth to his daughter, then his father getting killed in the crash of a light plane, and his mother passing away two years ago. I guess that goes to prove that there’s some things money can’t buy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tell ya’, I’d give a hundred dollars if I could remember that blond’s name,” Kelly declared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It won’t cost a hundred dollars,” the bartender replied cryptically. “Just the price of a phone call.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It took a second for the cowboy to follow his thinking. “You’re right!” Kelly scooped up the small change on the countertop. “Either Deke or Marissa will be home. I’ll just call and ask.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("He stepped off the barstool and headed toward ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("the pay telephone in the back hall by the rest rooms.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The walls in the den were cream-colored, giving the room an open, spacious feeling. A walnut gun cabinet stood near the door to the foyer, gleaming rifle barrels showing through its locked, glass door. Another area of the room was occupied by two overstuffed armchairs covered in roughly grained brown leather, worn smooth with age and usage. On the floor in front of the matching chairs was a large, woven mat, geometric designs stained into it with natural dyes. A massive desk dominated the room. A century old, its pecan wood was accented with heavy brass trappings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seated in the desk’s companion chair, Deke Blackwood made the day’s entries in the ledger opened before him. Having played in the den as a child, he was unimpressed by the aura of authority and power that was in the air.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("The responsibility that went along with the right to occupy the chair behind the desk had long ago wiped away the carefreeness of youth from his face. At thirty-two, he bore the stamp of experienced command. His hardened features were marked with lines of cynicism that seemed to look upon the world with weary humor. Handsome was no longer a word that described him, although all the ingredients were there—dark hair, the color of bronze—gray eyes with the sheen of polished steel—")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("and a rangy muscled build. He was like a wolf who had learned to survive by his wits and cunning, and no longer relied on mere good looks. In some intangible way, that altered his appearance.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A faint sound broke his concentration. His senses were trained to be ever on the alert. They became centered, now, on discovering the source of the sound—the whisper of soft material coming from the open door. Deke lifted his gaze from the column of figures and let it glide to the door. A young blond-haired girl was peering cautiously into the room, her look expectant and hopeful, one bare foot resting atop its mate. His mouth crooked in a half-smile at the sight of his daughter, but the fiercely possessive love in his eyes was more reflective of his true reaction. His glance skimmed her, taking note of the lavender nightgown and matching cotton robe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it that late-already?” Deke glanced at his watch as he closed his ledger book for the time being. His action was the indication Lindy Blackwood had been waiting for as she scampered into the room, darting around the desk to his chair. “I guess it is eight o’clock,” he acknowledged what his watch had revealed. He pivoted the swivel chair at right angles to the desk and lifted the child onto his knee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you through with your work?” Lindy asked with a glance at the closed account book.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“Not quite.” Deke studied his daughter with ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("an absolute pleasure. Lindy was the shining light in his life, practically the only one still left. He was highly protective of her, motivated by a certain selfishness. It was evident when he curved an arm around her small shoulders and snuggled her close to him. Bending his head, Deke brushed his mouth across the silkenness of her platinum hair. “Mmm, You smell good.”")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aunt Marissa let me put some of her perfume in my bath water.” She gave him a sidelong look, precociously testing her flirting skills. Little girls always tried them out on their own daddies first. For the time being, it amused him, but Deke wasn’t sure how he’d feel when she got older and turned her charms on some young man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re too anxious to grow up,” Deke murmured, because he knew how many ways she could be hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Lindy paid no attention to his remark. “My rock looks nice sitting on the desk next to yours.” She drew his glance to the large fossilized stone that acted as a paperweight and the little one sitting in its shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It certainly does,” Deke agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought I was lucky to find it, but Mrs. Gonzales said that I had sharp eyes,” Lindy repeated the praise from her teacher. “Angie asked me how I knew what it was and I told her about your rock.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The name vibrated through him. It was a slight shock to hear it spoken by his daughter. “Who is Angie? One of your classmates?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“No. Angie is the lady who was visiting Mrs. Gonzales at school today,” Lindy explained blithely. “When I brought my rock in to show my teacher, she asked to see it. She thought I was clever for remembering about yours.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was clever,” Deke echoed the praise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow I’m going to look for some more,” she stated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of tomorrow, it’s time you were getting to bed.” As he started to slide her off his lap, the telephone rang. After a second’s hesitation, he set her down. “Run along to bed,” Deke instructed while reaching to pick up the phone. “I’ll be there in a few minutes to tuck you in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Obediently, Lindy did as she was told. Deke watched her go, lifting the telephone receiver to silence its shrill ring, but not carrying it to his ear until his daughter had disappeared. The swivel chair squeaked as he leaned back in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blackwood.” He spoke into the mouthpiece.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deke? Kelly Reynolds,” the male voice on the other end of the phone identified himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mild surprise registered in Deke’s expression. “Hello, Kelly. How’ve you been?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine.” It was a quick reply, dismissing the pleasantries. “What I was calling about, Deke —Do you remember that blond you dated a few years back? She spent the summer here visiting some relative.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Deke stiffened, his blood running cold for an ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("instant. “Angie?” Harshness made it an accusing question.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Angie! That’s it!” Kelly exclaimed in satisfaction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deke leaned forward in his chair, his features growing hard. “What about her?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was here at Al’s, having a drink. I finally recognized her, but I couldn’t remember her name. I knew I would go crazy until I found out what it was, that’s why I called you.” He laughed shortly in mixed relief. “Now I can have some peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A white-hot rage began to thaw the coldness that had momentarily gripped Deke. A deadly quiet entered his voice. “Did she say what she was doing in town?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just passing through, she said,” Kelly replied indifferently. “I guess she’s spending the night here at the motel.” A muscle leaped along Deke’s jawline. “Well, I won’t keep ya’, Deke. Give Marissa my regards.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.” It was an absent response, a galling bitterness filling his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The line went dead. Deke replaced the telephone receiver on its cradle, visibly struggling to control the surge of raw anger that swept through him. Nearly possessed by it, he pushed out of his chair and circled the desk, crossing the room with long strides.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("In the foyer, he paused to drag his naturally tanned leather jacket from the halltree and clamp a charcoal black Stetson atop his head. ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("As he shrugged into the tailored jacket, footsteps approached the foyer. His steel gaze thrust itself into his dark-haired sister when she appeared. Her glance was startled.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you going?” Marissa frowned in confusion. “Lindy’s waiting for you to tell her good night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to go to town.” His answer was brisk, too severely controlled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was trouble in the air. Marissa could almost hear the crackling of electricity in the room. Something was very wrong or Deke wouldn’t be leaving without tucking Lindy into bed. But he was leaving—going into town, he said—without explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?” she blurted the demand and watched him pause, his hand on the doorknob. His gray eyes were cold and emotionless when they met her searching look. Yet she had the curious sensation of being burned as if a wild fire raged behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have there been any calls today that you failed to mention to me?” There was a hint of derision in his tone, a vague accusation that she had been deliberately keeping something from him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Despite the surface appearance of devotion, she and her brother had never been close—not in the sense that they confided in each other or shared their deepest thoughts. Marissa loved her brother and would have welcomed a ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("relationship like that, but Deke kept his own council, never allowing her to get too close. Marissa understood because he’d lost so many people that he cared about. If it wasn’t for Lindy, she would have believed that he’d lost the capacity to care about another human being. Their personalities had become very divergent. More than once Deke had accused her of being too softhearted and gullible. Such things hurt, just as his veiled challenge that she had deliberately kept something important from him now.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one called other than those on the list I left on your desk,” Marissa insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one?” His low drawl was almost taunting. “Not even Angie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shock wiped the color from her face, a reaction Deke’s sharp gaze was quick to note. It was impossible for his sister to hide her feelings. He was almost irritated with himself for doubting her loyalty, except he knew her feelings could be manipulated. And Angie was an expert at that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Angie,” Marissa whispered the name. “Has she . . . ?” She stopped before finishing the question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deke already knew what it was going to be. “Yes. Kelly says she’s in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And that’s where you’re going?” she breathed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("“Yes. I want to find out what’s on her cold, little mind.” A thick thread of embittered ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("anger ran through his voice. “If it’s trouble she wants, I’ll give her all she can handle.”")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deke—” Her voice seemed to plead with him not to be hasty, but he was already walking out the door.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a5766b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chp02.vue
// module id = 69
// module chunks = 0